import LazyPortsSelector from "./lazy-ports-selector.component";

export default LazyPortsSelector;
